// frontend/src/utils/runsOutSeverity.js
//
// "Runs out in" — how urgent a projected stockout is, from the day count the
// backend derives per request (PORecommendationLineSerializer.days_until_stockout,
// = ProjectedStockoutDate − the store's today: the day the shelf empties if
// nothing new is ordered, the same on every line of the item).
//
// The mapping only: the recommendation detail grid owns the chip and reads
// the label from `purchaseRecommendations.detail`.

export const RUNS_OUT_NONE = 'none';
export const RUNS_OUT_ALREADY = 'already';
export const RUNS_OUT_TODAY = 'today';
export const RUNS_OUT_SOON = 'soon';
export const RUNS_OUT_LATER = 'later';

/** Within this many days the line reads as a warning rather than plain text. */
export const RUNS_OUT_SOON_MAX_DAYS = 7;

/**
 * Classify a line's stock position: already empty, or days until it empties.
 *
 * @param {number|null|undefined} days — days until the projected stockout;
 *   null when no stockout is projected. Negative when the projected date is
 *   already behind us (the plan outlived its own projection).
 * @param {boolean} outOfStock — the line's is_out_of_stock flag. The day count
 *   cannot tell "runs out today" from "has been out for a week" (both count
 *   0), so the flag decides first. Required: a row without it is a wire
 *   contract break, not an item in stock.
 * @returns {string} one of the RUNS_OUT_* constants.
 */
export function runsOutSeverity(days, outOfStock) {
  if (typeof outOfStock !== 'boolean') {
    throw new TypeError(`runsOutSeverity: is_out_of_stock must be a boolean, got ${outOfStock}`);
  }
  if (outOfStock) return RUNS_OUT_ALREADY;
  if (days == null) return RUNS_OUT_NONE;
  if (days < 0) return RUNS_OUT_ALREADY;
  if (days === 0) return RUNS_OUT_TODAY;
  if (days <= RUNS_OUT_SOON_MAX_DAYS) return RUNS_OUT_SOON;
  return RUNS_OUT_LATER;
}
